 
import React, {createContext, useState} from 'react';

export const BridleContext = createContext();

const BridleContextProvider = props => {
    const defaultOptions = {
        Color: {
            ColorId: '',
            ColorName: ''
        },
        Crown: {
            productId: '',
            price: ''
        },
        Browband: {
            productId: '',
            price: ''
        },
        Cheek: {
            productId: '',
            price: ''
        },
        Noseband: {
            productId: '',
            price: ''
        },
        Reins: {
            productId: '',
            price: ''
        }
    };
    const [styles, setStyles] = useState();
    const [products, setProducts] = useState();
    const [options, setOptions] = useState(defaultOptions);

    return (
        <BridleContext.Provider value={{styles, setStyles, products, setProducts, options, setOptions, defaultOptions}}>
            {props.children}
        </BridleContext.Provider>
    );
};

export default BridleContextProvider;
